module.exports = __webpack_public_path__ + "media/images/emblems/Novalles-coat_of_arms-02f36c18ae6bd6c58b873fb0f2f1e667.svg";